module.exports = "/assets/data/32cdb25ceef5bcb00ce500dd481cc0da-WC1E.data.json";